// Promocja oferty prywatnych ubezpieczeń (tvp.uspartner.pl) — całoroczna.
// Zasady pokazywania (balans: nie drażnić, ale przypominać):
// - samo wyświetlenie (bez żadnej interakcji) — następne najwcześniej po 12 h,
// - zamknięcie X-em — cisza przez 15 dni,
// - kliknięcie w ofertę — cisza przez 45 dni (konwertującym nie przeszkadzamy).
// Dodatkowo okna wyłączenia (np. dni bez promocji) – patrz ../promoBlackout.js.
import { isPromoBlackout } from '../promoBlackout';

export const SHOWN_COOLDOWN_MS = 12 * 60 * 60 * 1000;
export const DISMISS_TTL_MS = 15 * 24 * 60 * 60 * 1000;
export const CLICK_TTL_MS = 45 * 24 * 60 * 60 * 1000;

const isFresh = (now, timestamp, ttl) =>
  Number.isFinite(timestamp) && now.getTime() - timestamp <= ttl;

export const parseOfferPromoState = (stateRaw) => {
  if (!stateRaw) {
    return {};
  }

  try {
    const state = JSON.parse(stateRaw);

    return state && typeof state === 'object' ? state : {};
  } catch (error) {
    return {};
  }
};

export const shouldShowOfferPromo = (now, stateRaw) => {
  if (isPromoBlackout(now)) {
    return false;
  }

  const state = parseOfferPromoState(stateRaw);

  if (isFresh(now, Number(state.clickedAt), CLICK_TTL_MS)) {
    return false;
  }

  if (isFresh(now, Number(state.dismissedAt), DISMISS_TTL_MS)) {
    return false;
  }

  if (isFresh(now, Number(state.shownAt), SHOWN_COOLDOWN_MS)) {
    return false;
  }

  return true;
};
